export default "__VITE_ASSET__80a2aaa6__"